import { render } from "./AddMontantPage.vue?vue&type=template&id=cad04e94&ts=true"
import script from "./AddMontantPage.vue?vue&type=script&lang=ts"
export * from "./AddMontantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__